// src/config/firebase_ppp.ts
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// 1. Paste the keys from your CONSUMER app (PricePlanPro) here
const pppConfig = {
  apiKey: "AIzaSyB6zpwTQ3hZmRg9H0SoKhqaKr1pdcZReb0",
  authDomain: "priceplanpro.firebaseapp.com",
  projectId: "priceplanpro",
  storageBucket: "priceplanpro.firebasestorage.app",
  messagingSenderId: "267480708806",
  appId: "1:267480708806:web:0a6faffc8229501486c9c7"
};

// 2. Initialize a SECONDARY app instance
// We give it a name "PPP_DATA_SOURCE" so it doesn't conflict with the main AiQ app
let pppApp;
if (!getApps().length) {
    pppApp = initializeApp(pppConfig, "PPP_DATA_SOURCE");
} else {
    // Check if it already exists to prevent re-initialization errors
    pppApp = getApps().find(app => app.name === "PPP_DATA_SOURCE") || initializeApp(pppConfig, "PPP_DATA_SOURCE");
}

// 3. Export the database connection
export const db_ppp = getFirestore(pppApp);